"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var CourseTypesModel = /** @class */ (function () {
    function CourseTypesModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/course-types",
            UPDATE: APPURL + "/api/v1/course-types",
            CREATE: APPURL + "/api/v1/course-types",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.get = this.get.bind(this);
        this.getByID = this.getByID.bind(this);
        this.update = this.update.bind(this);
        this.insert = this.insert.bind(this);
        this.remove = this.remove.bind(this);
    }
    CourseTypesModel.prototype.extract = function (result) {
        return result.data;
    };
    CourseTypesModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    CourseTypesModel.prototype.getByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    CourseTypesModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    CourseTypesModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    CourseTypesModel.prototype.insert = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    CourseTypesModel.prototype.remove = function (courseType) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + courseType.id)
            .then(this.cacheResults);
    };
    return CourseTypesModel;
}());
CourseTypesModel.$inject = ["$http", "APPURL"];
exports.default = CourseTypesModel;
